module.exports = __webpack_public_path__ + "img/expand.c101b9c6.svg";